import React from 'react';
import { Form } from 'react-bootstrap';
import { RotatingLines } from 'react-loader-spinner';

function ToggleSwitch({ disabled = false, isLoading, checked, onChange }) {
  return (
    <Form>
      {
        isLoading ?
          <RotatingLines
            height="20"
            width="20"
            strokeColor={`var(--bs-primary)`}
            strokeWidth="3"
            animationDuration="1"
          />
          :
          <Form.Check
            disabled={disabled}
            type="switch"
            checked={checked}
            onChange={onChange}
          />
      }
    </Form>
  );
}

export default ToggleSwitch;
